export const CART_RESTORE_PARAM = 'cart'

export const CART_LINK_FLAG = 'cart_link'

export const CART_LINK_INVALID = 'invalid'

export function withoutCartRestoreParam(query = {}) {
  const kept = {}

  Object.keys(query).forEach(key => {
    if (key !== CART_RESTORE_PARAM) {
      kept[key] = query[key]
    }
  })

  return kept
}

export function cartRestoreRedirectQuery(query = {}, { failed = false } = {}) {
  const kept = withoutCartRestoreParam(query)

  return failed ? { ...kept, [CART_LINK_FLAG]: CART_LINK_INVALID } : kept
}
